import {ISelectOption} from '@features/orders/interfaces';
import {getFilterSuggestions} from '@features/orders/services/getFilterSuggestions';

export function getArticles(searchText: string = ''): Promise<ISelectOption[]> {
    return getFilterSuggestions('article', searchText);
}